import Layout from "../components/layout";
import * as React from "react";
import {FaExternalLinkAlt} from "react-icons/fa";

const GeschenkePage = () => {
  return (
    <Layout title={'Geschenkideen'}>
      <section className="p-8">
        <h1 className={"text-2xl"}>
          Geschenkideen
        </h1>
        <p>
          Unser größtes Geschenk ist es, gemeinsam mit euch/dir zu feiern!
          Wenn ihr uns darüberhinaus eine Freude machen möchtet, haben wir unter
          <a className={"font-bold"} href={"https://www.hochzeits-tisch.de/tische/laura-johannes"} target={'_blank'} rel={'noreferrer'}> www.hochzeits-tisch.de/tische/laura-johannes </a>
          einen Geschenktisch eingerichtet.*
        </p>
        <div className={"flex flex-col items-center"}>
          <a href={"https://www.hochzeits-tisch.de/tische/laura-johannes"} target={'_blank'} rel={'noreferrer'} className={"p-4 bg-white border border-primary rounded text-2xl flex items-center"}>
            Hier geht's zum Hochzeitstisch
            <span className={"ml-4 text-xl"}><FaExternalLinkAlt/></span>
          </a>
          <div className="text-lg">*Passwort: XXXXX</div>
        </div>
        <p>
          Bei Fragen könnt ihr euch gerne bei Lauras Schwester Rebecca melden.
        </p>
      </section>
    </Layout>
  )
}

export default GeschenkePage
